import { signInAnonymously } from 'firebase/auth';
import { auth } from './firebaseConfig';

let authReadyPromise = null;

/**
 * Garante um usuário Firebase antes de gravar/enviar áudio.
 * No celular não há sessão de admin; login anônimo resolve storage/unauthorized.
 */
export function ensureResponderAuth() {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  if (!authReadyPromise) {
    authReadyPromise = (async () => {
      try {
        await auth.authStateReady();
        if (auth.currentUser) {
          return auth.currentUser;
        }
        const credential = await signInAnonymously(auth);
        return credential.user;
      } catch (error) {
        authReadyPromise = null;
        throw error;
      }
    })();
  }

  return authReadyPromise;
}
